module.exports = __webpack_public_path__ + "img/cancel.06d8e087.png";